export const POWERED_BY_LABEL = 'Powered by Lender Optimus';
export const POWERED_BY_HREF = 'https://www.lender.com';
export const EQUAL_HOUSING_LABEL = 'Equal Housing Lender';
export const NMLS_PREFIX = 'NMLS #';
